import { AppFooterPublic } from "./AppFooterPublic";

export const AppFooterPrivate = (props) => (
  <AppFooterPublic {...props} isPrivate />
);
